'use strict';

import $ from 'jquery';

/**
 * Opens user menu on click
 */
const toggleDropdown = {

  init: function() {
    $('.has-dropdown').mouseenter(function(e){
      $(this).find('ul').slideDown(200);
    }).mouseleave(function(){
      $(this).find('ul').slideUp(200);
    })
  }
};

module.exports = toggleDropdown;
